export const zoomDashboardUrl = "/playground/zoom/dashboard"
export const zoomInFrameUrl = "/playground/zoom/in-frame"
export const zoomInFrameLeaveUrl = zoomInFrameUrl + "/finished"
export const zoomLiveStreamingUrl = "/playground/zoom/live-streaming"